<template>
  <div class="chart">
    <div class="page-container">
      <div class="user-card">
        <div class="card-top">
          <div class="user-info">
            <div class="user-avatar" :style="{
              backgroundImage: 'url(' + user.headimgurl + ')'
            }"></div>
            <div class="user-name">{{ user.nickname }}</div>
          </div>
          <div class="user-code" @click="showWxacode = true" v-if="user.share_acode">
            <van-icon name="qr" />
          </div>
        </div>
      </div>
      <div class="navi-actions">
        <div class="act-item" @click="showQrform = true">
          <van-icon name="qr" /> 二维码设置
        </div>
      </div>
      <div class="board-container">
        <div class="board-item">
          <div class="board-title">昨日新增</div>
          <div class="board-icon">
            <van-icon name="flag-o" />
          </div>
          <div class="board-number">
            {{ stat ? stat.new_customer : '-' }}
          </div>
        </div>
        <div class="board-item bg-blue">
          <div class="board-title">会员总数</div>
          <div class="board-icon">
            <van-icon name="clock-o" />
          </div>
          <div class="board-number">
            {{ stat ? stat.total_customer : '-' }}
          </div>
        </div>
      </div>
      <div class="action-list">
        <div class="action-title">
          往期数据
        </div>
        <van-cell-group>
          <van-cell size="large" icon="video-o" title="观看人数" is-link to="/GMStat/play" />
          <van-cell size="large" icon="records" title="答题人数" is-link to="/GMStat/question" />
          <van-cell size="large" icon="gift-card-o" title="发布红包" is-link to="/GMStat/redpack" />
        </van-cell-group>
        <!--
        <div class="logout-function">
          <van-button plain type="info" block @click="doLogout">退出</van-button>
        </div>
        -->
      </div>
    </div>
    <van-popup v-model="showQrform">
      <div class="qrcode-form">
        <div class="title">联系二维码</div>
        <van-uploader :after-read="afterRead">
          <div class="qrcode">
            <template v-if="user.friendcode">
              <img :src="res_url + 'fc/' + user.friendcode" />
            </template>
            <template v-else>
              <van-icon name="plus" size="28" color="#999" />
            </template>
            <div class="loading" v-if="is_uploading">
              <van-loading size="24px" vertical>上传中...</van-loading>
            </div>
          </div>
        </van-uploader>
        <div class="info">
          {{ user.friendcode ? '点击上方区域可重新上传' : '点击上方区域上传好友二维码'}}
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showWxacode" style="background: transparent">
      <div class="wxacode">
        <img :src="wxAcode" />
      </div>
    </van-popup>
    <Footer />
    <GMError />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import GMError from './component/GMError.vue';
import { mapState } from 'vuex'
// import { logout } from '@/api'
import { fcSave } from '@/api/group_master'
import { baseStat } from '@/api/stats'
import { fcCodeUpload } from '@/utils/cos-upload'

export default {
  name: 'GMChart',
  components: {
    Footer,
    GMError
  },
  data() {
    return {
      showQrform: false,
      showWxacode: false,
      is_uploading: false,
      stat: null
    }
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapState(['user']),
    res_url() {
      return window.__config__.res_url;
    },
    wxAcode() {
      if (this.user.share_acode) {
        return window.__config__.server_url + 'wxa_code/group_master/' + this.user.share_acode
      }
      return '';
    },
  },
  methods: {
    init() {
      baseStat().then(async (resp) => {
        if ('data' in resp) {
          this.stat = resp.data
        }
      })
    },
    /*
    doLogout() {
      logout().then(async (resp) => {
        await this.$store.dispatch('syncUser')
        if ('state' in resp.data) {
          this.$router.replace('/login?state=' + resp.data.state)
        }
      })
    },
    */
    afterRead(e) {
      let that = this;
      that.is_uploading = true;
      console.log(e)
      fcCodeUpload({
        ...e,
        onError(err) {
          that.is_uploading = false;
          console.log('onError', err)
        },
        onSuccess(evt) {
          console.log('onSuccess', evt)
          fcSave(evt.Key).then(resp => {
            console.log(resp)
            if ('friendcode' in resp) {
              that.$store.commit('UPDATE_FRIENDCODE', resp.friendcode)
            }
            that.is_uploading = false;
          }).catch(err => {
            that.is_uploading = false;
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.user-card {
  background: #5171ea;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 10px;

  .card-top {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;

    .user-info {
      padding: 6px 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      .user-avatar {
        width: 60px;
        height: 60px;
        border-radius: 30px;
        margin-bottom: 10px;
        background-size: cover;
        background-position: center;
      }

      .user-name {
        font-size: 18px;
        font-weight: 400;
      }
    }

    .user-code {
      position: absolute;
      font-size: 36px;
      right: 0px;
      top: 0px;
    }
  }

}
.navi-actions {
  margin: 10px 0;
  .act-item {
    cursor: pointer;
    background: #fefefe;
    border-radius: 6px;
    padding: 8px 6px;
    text-align: center;
    box-shadow: 0px 10px 20px rgb(33 39 65 / 8%);
  }
}

.board-container {
  padding: 5px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;

  .board-item {
    width: calc(48vw - 10px);
    height: 30vw;
    position: relative;
    border-radius: 6px;
    background: #607eee;
    color: #fff;

    &.bg-blue {
      background: #8fc5d0;
    }

    .board-title {
      position: absolute;
      top: 12px;
      left: 12px;
    }

    .board-icon {
      position: absolute;
      right: 12px;
      top: 12px;
      font-size: 40px;
    }

    .board-number {
      position: absolute;
      bottom: 26px;
      left: 12px;
      font-size: 28px;
    }
  }
}

.action-list {
  padding: 5px 0;

  .action-title {
    padding: 0 0 5px 0;
    margin: 10px 0 15px 0;
    font-size: 16px;
    border-bottom: 4px solid #73b684;
    display: inline-block;
  }

  .logout-function {
    margin-top: 20px;
  }
}
.qrcode-form {
  width: 80vw;
  height: 94vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  .title {
    font-size: 18px;
    font-weight: 600;
    margin: 12px 0 12px 0;
  }
  .qrcode {
    position: relative;
    width: 60vw;
    height: 60vw;
    border: 2px solid #999;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    img {
      width: 100%;
      height: 100%;
    }
    .loading {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 2;
    }
  }
  .info {
    margin: 18px 0 12px 0;
    text-align: center;
    font-size: 14px;
  }
}
.wxacode {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}
.wxacode img {
  margin: 10px;
  max-width: 75vw;
}
</style>
